/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var GarageSpotEquipmentStatus;
(function (GarageSpotEquipmentStatus) {
    GarageSpotEquipmentStatus["Issued"] = "Issued";
    GarageSpotEquipmentStatus["InStorage"] = "InStorage";
    GarageSpotEquipmentStatus["RemovedFromStorage"] = "RemovedFromStorage";
})(GarageSpotEquipmentStatus || (GarageSpotEquipmentStatus = {}));
export function GarageSpotEquipmentStatusFromJSON(json) {
    return GarageSpotEquipmentStatusFromJSONTyped(json, false);
}
export function GarageSpotEquipmentStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function GarageSpotEquipmentStatusToJSON(value) {
    return value;
}
